// removed by extract-text-webpack-plugin
module.exports = {"main":"_1AzpXmxtXrve22LTzOhAAS","secret":"_1iuDG8R2vuVVpOSL_CLcxE","accessKey":"_3OESvvc4aTJo7u1jII2L3H"};


//////////////////
// WEBPACK FOOTER
// ./components/Customers/CustomersSettings.module.css
// module id = 2344
// module chunks = 1